@if ({ declineReason: declineReasonText$ | async, contact: currentContact$ |
async, isDesktop: isDesktop$ | async, localParticipant: localParticipant$ |
async, remoteParticipant: remoteParticipant$ | async, localMediaStatus:
localParticipantMediaStatus$ | async, remoteMediaStatus:
remoteParticipantMediaStatus$ | async, isScreenSharing: isScreenSharing$ |
async, isPictureInPicture: isPictureInPicture$ | async, currentUser:
currentUser$ | async, lightModeActive: lightModeActive$ | async, elapsedTime:
elapsedTime$ | async, mediaAccessDenied: mediaAccessDenied$ | async,
isConnectionDone: isConnectionDone$ | async }; as context) {
<div class="connect-call" [class.invisible]="context.lightModeActive">
  <div class="connect-call_toolbar"></div>
  <div class="connect-call_container">
    <div class="connect-call_remote_participant">
      <ng-container *ngTemplateOutlet="remoteParticipantTpl"></ng-container>
      @if ( !context.isDesktop && !context.remoteParticipant &&
      !context.declineReason && !context.isConnectionDone ) {
      <div class="inset-cover">
        <ng-container *ngTemplateOutlet="ringTpl"></ng-container>
        <ng-container *ngTemplateOutlet="localParticipantTpl"></ng-container>
      </div>
      }
    </div>
    <div class="connect-active_call">
      @if (context.isDesktop) {
      <div class="connect-active_call_top_content">
        <div class="connect-active_call_remote_info">
          <ng-container
            *ngTemplateOutlet="contactInformationTpl"
          ></ng-container>
        </div>
        <div class="connect-active_call_actions">
          <ng-container *ngTemplateOutlet="pipBtnTpl"></ng-container>
          <button (click)="finalizeCall()" class="connect-action_button">
            <fa-icon [icon]="['fas', 'xmark']"></fa-icon>
          </button>
        </div>
      </div>
      }
      <div class="connect-active_call_middle_content">
        <div
          class="w-100 h-100 d-flex justify-content-center align-items-center px-4"
        >
          @if (context.mediaAccessDenied) {
          <h3
            class="text-white text-center container-sm"
            i18n="
              Connect|Connect camera and audio access
              error@@connectCameraAndMicrophonePermissionsError"
          >
            You didn't give permssion to use camera and microphone. Therefore
            you cannot use this feature. If you would like to give the
            permissions, go to your browser's settings and provide camera and
            microphone access from there.
          </h3>
          } @else { @if ( !context.declineReason && !context.remoteParticipant
          && !context.isConnectionDone && context.contact && context.isDesktop )
          {
          <ng-container *ngTemplateOutlet="ringTpl"></ng-container>
          <ng-container *ngTemplateOutlet="callLoaderTpl"></ng-container>
          } @if (context.isConnectionDone && !context.remoteParticipant) {
          <h3
            i18n="
              Connect|Connect participant left
              call@@connectParticipantLeftCallTitle"
            class="text-white"
          >
            {{ context.contact?.displayName }} has left the call
          </h3>
          } @if (context.declineReason) {
          <h3 class="text-white">{{ context.declineReason }}</h3>
          } }
        </div>
      </div>
      <div class="connect-active_call_bottom_content">
        @if (!context.isDesktop) {
        <div class="connect-active_call_mobile_contact">
          <ng-container
            *ngTemplateOutlet="contactInformationTpl"
          ></ng-container>
          <ng-container *ngTemplateOutlet="callElapsedTimeTpl"></ng-container>
        </div>
        }
        <div class="connect-active_call_controls">
          @if (context.isDesktop) {
          <div class="connect-active_call-settings">
            <button
              (click)="openSettings($event)"
              class="connect-action_button mr-3"
            >
              <fa-icon size="1x" [icon]="['fas', 'gear']"></fa-icon>
            </button>
            <ng-container *ngTemplateOutlet="callElapsedTimeTpl"></ng-container>
          </div>
          }
          <ng-container *ngTemplateOutlet="screenShareBtnTpl"></ng-container>
          <ng-container *ngTemplateOutlet="microphoneBtnTpl"></ng-container>
          <ng-container *ngTemplateOutlet="cameraBtnTpl"></ng-container>
          <ng-container *ngTemplateOutlet="phoneBtnTpl"></ng-container>
        </div>
        @if (context.isDesktop) {
        <div class="connect-call_local_participant">
          <ng-container *ngTemplateOutlet="localParticipantTpl"></ng-container>
        </div>
        }
      </div>
      <atx-aside-menu
        class="aside-menu"
        [open]="settingsOpened"
        [useOverlay]="false"
        placement="left"
        (openStateChange)="handleClose($event)"
      >
        <div
          class="menu-title d-flex align-items-center px-3 py-2 border-bottom border-light justify-content-between"
        >
          <h6
            class="m-0 font-weight-medium"
            i18n="
              Connect|Connect settings header title@@connectSettingsHeaderTitle"
          >
            Devices Settings
          </h6>
          <button
            class="btn btn-round btn-light ml-3"
            (click)="settingsOpened = false"
            data-e2e="user-menu-close"
          >
            <fa-icon [icon]="['fas', 'xmark']" size="xs"></fa-icon>
          </button>
        </div>
        <div class="menu-content h-100" data-e2e="connect-call-settings">
          <epc-connect-settings
            (audioInputChange)="onAudioInputChange($event)"
            (videoInputChange)="onVideoInputChange($event)"
            (audioOutputChange)="onAudioOutputChange($event)"
          ></epc-connect-settings>
        </div>
      </atx-aside-menu>
    </div>
  </div>
</div>
<div class="connect-call draggable" [class.d-none]="!context.lightModeActive">
  <div
    cdkDrag
    cdkDragRootElement="connect-call"
    cdkDragBoundary=".cdk-overlay-pane"
    class="connect-call_remote_pip"
  >
    <div class="connect-call_remote_pip">
      <div class="inset-cover">
        <ng-container *ngTemplateOutlet="remoteParticipantTpl"></ng-container>
      </div>
      @if (!context.remoteParticipant) {
      <div class="inset-cover d-flex justify-content-center align-items-center">
        <ng-container *ngTemplateOutlet="callLoaderTpl"></ng-container>
      </div>
      }
      <div class="inset-cover d-flex align-items-end">
        <div class="connect-call_remote_pip_actions">
          @if (context.isPictureInPicture) {
          <ng-container *ngTemplateOutlet="pipBtnTpl"></ng-container>
          } @else {
          <ng-container *ngTemplateOutlet="screenShareBtnTpl"></ng-container>
          }
          <ng-container *ngTemplateOutlet="microphoneBtnTpl"></ng-container>
          <ng-container *ngTemplateOutlet="phoneBtnTpl"></ng-container>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="inset-cover"></div>
    <ng-container *ngTemplateOutlet="videoCallActions"></ng-container>
  </div> -->
</div>
<ng-template #localParticipantTpl>
  <epc-participant-camera
    id="localParticipant"
    [participant]="context.localParticipant"
    [mediaStatus]="context.localMediaStatus"
    [contact]="context.currentUser"
    [isLocal]="true"
    #localParticipant
  ></epc-participant-camera>
</ng-template>
<ng-template #remoteParticipantTpl>
  @if (context.remoteParticipant) {
  <epc-participant-camera
    [participant]="context.remoteParticipant"
    [mediaStatus]="context.remoteMediaStatus"
    [contact]="context.contact"
    #remoteParticipant
  ></epc-participant-camera>
  }
</ng-template>
<ng-template #pipBtnTpl>
  <ng-container>
    <button
      [disabled]="!context.remoteParticipant"
      (click)="togglePictureInPicture(context.isPictureInPicture)"
      [atxTooltip]="
        context.isPictureInPicture
          ? pictureInPictureOffText
          : pictureInPictureOnText
      "
      tooltipPlacement="bottom"
      class="connect-action_button"
      data-e2e="connect-pip-toggle"
    >
      <fa-icon
        [rotate]="90"
        [icon]="
          context.isPictureInPicture
            ? ['fas', 'up-right-and-down-left-from-center']
            : ['fas', 'arrow-down-left-and-arrow-up-right-to-center']
        "
      ></fa-icon>
    </button>
  </ng-container>
</ng-template>
<ng-template #screenShareBtnTpl>
  @if (context.isDesktop) {
  <button
    [disabled]="!context.remoteParticipant"
    (click)="toggleScreenShare(context.isScreenSharing)"
    [atxTooltip]="
      context.isScreenSharing ? screenShareOffText : screenShareOnText
    "
    tooltipPlacement="bottom"
    class="connect-action_button"
    data-e2e="connect-screen-share-toggle"
    [class.danger]="context.isScreenSharing"
  >
    <fa-icon [icon]="['fas', 'display']"></fa-icon>
  </button>
  }
</ng-template>
<ng-template #microphoneBtnTpl>
  <button
    (click)="toggleMicrophone()"
    [atxTooltip]="
      context.localMediaStatus?.microphoneEnabled
        ? microphoneOffText
        : microphoneOnText
    "
    tooltipPlacement="bottom"
    class="connect-action_button"
    data-e2e="connect-microphone-toggle"
  >
    @if ( context.localMediaStatus?.microphoneEnabled) {
    <fa-icon [icon]="['fas', 'microphone']"></fa-icon>
    } @else {
    <fa-icon [icon]="['fas', 'microphone-slash']"></fa-icon>
    }
  </button>
</ng-template>
<ng-template #cameraBtnTpl>
  <button
    (click)="toggleCamera()"
    [atxTooltip]="
      context.localMediaStatus?.cameraEnabled ? cameraOffText : cameraOnText
    "
    tooltipPlacement="bottom"
    class="connect-action_button"
    data-e2e="connect-camera-toggle"
  >
    @if (context.localMediaStatus?.cameraEnabled) {
    <fa-icon [icon]="['fas', 'video']"></fa-icon>
    } @else {
    <fa-icon [icon]="['fas', 'video-slash']"></fa-icon>
    }
  </button>
</ng-template>
<ng-template #phoneBtnTpl>
  <button
    (click)="finalizeCall()"
    class="connect-action_button bg-danger"
    data-e2e="connect-finalize-call"
  >
    <fa-icon [icon]="['fas', 'phone-slash']"></fa-icon>
  </button>
</ng-template>
<ng-template #callLoaderTpl>
  <div
    class="connect-active_call_loader"
    [class.picture-in-picture]="context.lightModeActive"
  >
    @if (!context.isConnectionDone) {
    <div class="connect-active_call_pulse-container"></div>
    }
    <atx-avatar
      [fullName]="context.contact?.displayName"
      [image]="context.contact?.imageLink"
      size="xxl"
    ></atx-avatar>
  </div>
</ng-template>
<ng-template #contactInformationTpl>
  <h5 class="text-white">{{ context.contact?.displayName }}</h5>
  @if (!context.remoteMediaStatus?.microphoneEnabled) {
  <fa-icon class="ml-2" [icon]="['fas', 'microphone-slash']"></fa-icon>
  }
</ng-template>
<ng-template #callElapsedTimeTpl>
  @if (context.remoteParticipant) {
  <p class="text-white mb-0">{{ context.elapsedTime }}</p>
  }
</ng-template>
}

<ng-template #ringTpl>
  <audio autoplay loop>
    <source src="assets/media/ring.mp3" type="audio/mpeg" />
  </audio>
</ng-template>
